import { j as s } from "../../../jsx-runtime-BwWtxLpl.js";
import "react";
import i from "prop-types";
const l = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), m = ({ value: e = "", searchTerm: r = "" }) => {
  if (!r.trim())
    return /* @__PURE__ */ s.jsx("span", { children: e });
  const p = new RegExp(`(${l(r)})`, "gi"), n = e.split(p);
  return /* @__PURE__ */ s.jsx("span", { className: "motif-default-template", children: n.map(
    (t, o) => p.test(t) ? /* @__PURE__ */ s.jsx("strong", { style: { fontWeight: "bold" }, children: t }, o) : t
  ) });
};
m.propTypes = {
  value: i.string.isRequired,
  searchTerm: i.string
};
export {
  m as DefaultOptionTemplate
};
